import { z } from 'zod';

export const WarehouseCountrySchema = z.enum(['VN', 'TH', 'PH', 'ID', 'MY']);
export type WarehouseCountry = z.infer<typeof WarehouseCountrySchema>;

export const WarehouseSchema = z.object({
  id: z.string().uuid().or(z.string().min(1)),
  code: z.string().min(1), // VN-HN-01
  name: z.string().min(1), // Hà Nội — Long Biên
  country: WarehouseCountrySchema,
  region: z.string().min(1), // North / South / Central
  capacity_orders_per_day: z.number().int().positive(),
  is_active: z.boolean().default(true),
  created_at: z.string().datetime().or(z.string()),
});
export type Warehouse = z.infer<typeof WarehouseSchema>;
